import { DataLayer } from '@websrc/App/Components/DataLayer'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { useBasketStateOptional } from '@websrc/Basket/useBasketState'
import { QuoteNumber } from '@websrc/Checkout/Components/QuoteNumber/QuoteNumber'
import React from 'react'

import * as SC from './CartModal.style'
import { CartModalEmpty } from './Empty/CartModalEmpty'
import { CartModalFooter } from './Footer/CartModalFooter'
import { CartModalItemList } from './ItemList/CartModalItemList'

export interface ICartModalProps {
  onClose: () => void
}

export const CartModal = ({ onClose }: ICartModalProps) => {
  const basketState = useBasketStateOptional()
  const t = useStaticText()
  const hasItems = Boolean(basketState?.items.length)

  return (
    <DataLayer.Set
      condition={true}
      debugMessage={'CartModal'}
      revertWhenUnmounted={true}
      values={{
        site: {
          section: 'legoeducation:checkout',
        },
        page: {
          events: 'cart view',
        },
        page_name: 'legoeducation:checkout:cart_overlay',
        page_section: 'legoeducation:checkout',
        page_type: 'checkout',
      }}
    >
      <SC.Content>
        <SC.Title>{t.shopping_cart.your_cart}</SC.Title>
        <QuoteNumber />
        {!hasItems && <CartModalEmpty onClose={onClose} />}
        {hasItems && <CartModalItemList />}
        {hasItems && <CartModalFooter />}
      </SC.Content>
    </DataLayer.Set>
  )
}
